module.exports = "/_next/static/images/mm-f06bd610c7db734dc62d1e001e4a6a38.svg";